// ES
export const hotelRoomsManager = {
  header: {
    eyebrow: "Habitaciones del hotel",
    title: "Gestión de habitaciones",
    subtitle:
      "Crea los tipos de habitación y genera las unidades físicas con su numeración. Estas habitaciones se sincronizarán con Channex.",
    addRoom: "Agregar habitación",
  },
  states: {
    loading: "Cargando habitaciones...",
    emptyTitle: "Sin habitaciones todavía",
    emptySubtitle:
      "Crea el primer tipo de habitación para empezar a configurar tarifas y disponibilidad en Channex.",
    addFirstRoom: "Agregar primera habitación",
  },
  card: {
    roomsBadge: "{count} hab. | {count} hab.",
    maxGuests: "Máx. {count} huésp.",
    editTitle: "Editar habitación",
    deleteTitle: "Eliminar habitación",
    adults: "{count} adulto | {count} adultos",
    children: "{count} niño | {count} niños",
    infants: "{count} bebé | {count} bebés",
    units: "Unidades",
  },
  physical: {
    title: "Habitaciones físicas",
    subtitle:
      "Edita el número o el nombre de cada habitación, o pásala a otro tipo. Sus reservas se van con ella. Arrástralas por el asa para ordenarlas dentro de su tipo: ese es el orden con el que las verás en el calendario.",
    roomsCount: "{count} habitación | {count} habitaciones",
    savingOrder: "Guardando orden…",
    selectAll: "Seleccionar todas",
    clearSelection: "Quitar selección",
    dragToOrder: "Arrastrar para ordenar",
    selectRoom: "Seleccionar {label}",
    roomFallback: "habitación",
    codePlaceholder: "Nº / código",
    namePlaceholder: "Nombre",
  },
  bar: {
    selectedCount: "habitación seleccionada | habitaciones seleccionadas",
    clearSelection: "Quitar selección",
    changeType: "Cambiar de tipo",
  },
  modal: {
    createTitle: "Nueva habitación",
    editTitle: "Editar habitación",
    createSubtitle: "Define el tipo y genera las unidades físicas",
    editSubtitle: "Actualiza los datos del tipo de habitación",
    basicInfo: "Información básica",
    nameLabel: "Nombre de la habitación",
    namePlaceholder: "Ej: Habitación Doble, Suite Junior…",
    descriptionLabel: "Descripción",
    optional: "(opcional)",
    descriptionPlaceholder: "Vista al mar, terraza, minibar…",
    inventorySection: "Inventario y capacidad",
    countLabel: "Cantidad de habitaciones",
    countHintZero:
      "Se crea sin ninguna habitación: luego le asignas habitaciones que ya existen desde la lista de habitaciones físicas.",
    countHint: "Total de unidades físicas de este tipo",
    capacityLabel: "Capacidad total (huéspedes)",
    capacityHint: "Máximo permitido entre adultos + niños + bebés",
    priceLabel: "Precio por noche",
    priceHint:
      "Con esto se crea su tarifa estándar. Podrás afinarla después en «Tarifas del hotel».",
    adultsLabel: "Adultos",
    childrenLabel: "Niños",
    infantsLabel: "Bebés",
    numberingSection: "Numeración de habitaciones",
    toggleOn: "Activada",
    toggleOff: "Desactivada",
    numberingHintCreate:
      "Las habitaciones se crean con un código automático. Puedes cambiarlo una a una en la lista de habitaciones físicas, o fijar la numeración desde «Editar» para que las siguientes ya nazcan con ella.",
    prefixLabel: "Prefijo del código",
    prefixPlaceholder: "Ej: 10  o  A-",
    prefixHint: 'Ej: prefijo "10" + inicio 1 → 101, 102…',
    startNumberLabel: "Número inicial",
    paddingLabel: "Padding",
    paddingHint: "3 → 001, 002…",
    nameModeLabel: "Nombre de las habitaciones físicas",
    nameModeType: "Solo tipo",
    nameModeTypeExample: "Doble",
    nameModeTypeCode: "Tipo + código",
    nameModeTypeCodeExample: "Doble 101",
    preview: {
      lead: "Se crearán",
      roomsNoun: "habitación | habitaciones",
      withNumbering: "con esta numeración. Ejemplo:",
    },
    numberingHintKeep:
      "Las habitaciones que ya existen conservan su número. Esta numeración se aplicará a las que añadas a partir de ahora.",
    numberingHintZero:
      "Sin habitaciones no hay nada que numerar. Asígnale habitaciones existentes desde la lista de habitaciones físicas.",
    numberingHintDisabled:
      "Las habitaciones físicas no se generarán automáticamente. Puedes activarlo cuando quieras.",
    cancel: "Cancelar",
    saving: "Guardando…",
    creating: "Creando…",
    saveChanges: "Guardar cambios",
    createRoom: "Crear habitación",
  },
  delete: {
    title: "Eliminar habitación",
    subtitle: "Esta acción no se puede deshacer",
    confirmCopy: "Escribe el nombre de la habitación para confirmar:",
    placeholder: "Nombre de la habitación",
    cancel: "Cancelar",
    deleting: "Eliminando...",
    confirm: "Eliminar",
  },
  change: {
    title: "Cambiar el tipo {target}",
    subtitle: "El número de la habitación no cambia",
    newTypeLabel: "Nuevo tipo",
    newTypePlaceholder: "Elige a qué tipo pasa…",
    blocksHead: "Una reserva impide el cambio | {count} reservas impiden el cambio",
    moves: "Se mueve al tipo nuevo",
    stays: "Se queda en su tipo actual",
    addMissing: "Añadir {labels} al cambio y reintentar",
    stockLabel: "Habitaciones a la venta",
    checkingReservations: "Comprobando qué reservas hay en {target}…",
    thisRoom: "esta habitación",
    theseRooms: "estas habitaciones",
    theRoom: "la habitación",
    theRooms: "las habitaciones",
    noReservations: "No hay ninguna reserva en {target}.",
    reservationsLeave: "reserva se va | reservas se van",
    with: "con {target}",
    moreReservations: "y {count} reserva más | y {count} reservas más",
    greyLegend: "Las habitaciones en gris se quedan en su tipo actual.",
    retry: "Reintentar",
    cancel: "Cancelar",
    applying: "Cambiando…",
    confirm: "Sí, cambiar de tipo",
    titleTargetOne: "de la habitación {label}",
    titleTargetMany: "de {count} habitación | de {count} habitaciones",
    textZero: "Estas habitaciones ya son de ese tipo: elige otro para moverlas.",
    textOne:
      "La habitación se queda con su número y con sus reservas: solo cambia el tipo con el que se vende. Donde está ahora habrá una habitación menos a la venta y en el tipo nuevo, una más.",
    textMany:
      "Las {count} habitaciones se quedan con su número y con sus reservas: solo cambia el tipo con el que se venden. Donde están ahora habrá {count} habitaciones menos a la venta y en el tipo nuevo, {count} más.",
  },
  blockTitles: {
    huespedDentro: "Hay un huésped alojado",
    reservaRepartida: "La reserva ocupa otras habitaciones",
    reservaSinAsignar: "La reserva no tiene todas sus habitaciones",
    fallback: "No se puede mover",
  },
  groups: {
    noType: "Sin tipo asignado",
  },
  reservation: {
    noName: "Sin nombre",
  },
  toasts: {
    roomsChanged: "Habitación cambiada de tipo | {count} habitaciones cambiadas de tipo",
    changedSyncing: "{done} · actualizando los canales",
    created: "Habitación creada correctamente",
    updated: "Habitación actualizada",
    deleted: "Habitación eliminada",
  },
  errors: {
    generic: "Ocurrió un error.",
    loadRooms: "Error al cargar las habitaciones",
    updateQty: "No se pudo actualizar la cantidad",
    savePhysicalRoom: "No se pudo guardar la habitación",
    saveOrder: "No se pudo guardar el orden de las habitaciones.",
    checkReservations: "No se pudo comprobar qué reservas hay en estas habitaciones.",
    changeType: "No se pudo cambiar el tipo de la habitación.",
    noProperty: "No se pudo obtener el alojamiento. Inténtalo de nuevo.",
    saveRoom: "Error al guardar la habitación",
    deleteRoom: "Error al eliminar",
  },
};
